import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthUserSettingsService {
  public numbersView$ = new BehaviorSubject<string>('1.2-2');
  public percentsOneNumBeforeDotView$ = new BehaviorSubject<string>('1.2-3');
  public percentsTwoNumBeforeDotView$ = new BehaviorSubject<string>('1.1-2');
}
